import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { HomeComponent } from "@app/home/home.component";

import { FirmenComponent } from "@app/firmen/firmen.component";
import { FirmaComponent } from "@app/firma/firma.component";
import { HistoryComponent } from "@app/history/history.component";

import { AufgabeComponent } from "@app/aufgabe/aufgabe.component";
import { AufgabenComponent } from "@app/aufgaben/aufgaben.component";

const routes: Routes = [
  {
    path: 'start',
    component: HomeComponent
  },
  {
    path: 'aufgaben',
    canActivate: [MsalGuard],
    component: AufgabenComponent
  },
  {
    path: 'aufgabe/:id',
    component: AufgabeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'aufgabe/direct/:id',
    component: AufgabeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'firmen',
    canActivate: [MsalGuard],
    component: FirmenComponent,
  },
  {
    path: 'firma/:id',
    component: FirmaComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'historie/:id',
    component: HistoryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'firma/:firmenId/historie/:firmenstandorteId',
    component: HistoryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    component: HomeComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
